import React from 'react';
import { Grid } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import { UnderlinedTextInput, Text, Colors } from 'library';
import PhoneNumberInput from '../PhoneNumberInput';
import FormSection from './FormSection';

interface PersonalInfoSectionProps {
    firstName: string;
    setFirstName: (value: string) => void;
    lastName: string;
    setLastName: (value: string) => void;
    phoneDisplay: string;
    onPhoneChange: (value: string, display: string) => void;
    phoneError: boolean;
    phoneErrorText: string;
    expanded: boolean;
    complete: boolean;
    onToggle: () => void;
    onNext: () => void;
}

export default function PersonalInfoSection({
    firstName,
    setFirstName,
    lastName,
    setLastName,
    phoneDisplay,
    onPhoneChange,
    phoneError,
    phoneErrorText,
    expanded,
    complete,
    onToggle,
    onNext,
}: PersonalInfoSectionProps) {
    return (
        <FormSection
            title="Personal Information"
            icon={<PersonIcon />}
            expanded={expanded}
            complete={complete}
            onToggle={onToggle}
            onNext={onNext}
            autoFocusId="signup-first-name"
        >
            <Grid item sm={6} xs={12}>
                <UnderlinedTextInput
                    id="signup-first-name"
                    label="First Name*"
                    value={firstName}
                    onChange={setFirstName}
                    error={false}
                    errorText=""
                />
            </Grid>
            <Grid item sm={6} xs={12}>
                <UnderlinedTextInput
                    id="signup-last-name"
                    label="Last Name*"
                    value={lastName}
                    onChange={setLastName}
                    error={false}
                    errorText=""
                />
            </Grid>
            <Grid item sm={6} xs={12}>
                <PhoneNumberInput
                    id="signup-phone"
                    label="Phone*"
                    onChange={onPhoneChange}
                    value={phoneDisplay}
                    error={phoneError}
                    errorText={phoneErrorText}
                />
                <Text variant="body2" textStyle={{ marginTop: 4 }} color={Colors.grey}>
                    We recommend using a mobile number.
                </Text>
            </Grid>
        </FormSection>
    );
}
